import useMutationApi from 'src/api/useMutationApi';

const useDeleteSalesOrderDraft = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<void>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}`,
    method: 'DELETE',
    options: {
      onSuccess,
    },
  });
};

export default useDeleteSalesOrderDraft;
